import { Box } from "@mui/material";
import CommonLayout from "../../CommonComponent/CommonLayout";
import {
  CommonBuilderListButton,
  CommonBuilderListHeader,
  CommonBuilderListTitle,
} from "../Common/CommonListComponent";

const BuilderListLayout = ({
  title,
  headerTitle,
  buttonTitle,
  handleSearch,
  children,
  onClick,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: "24px",
        flexDirection: "column",
      }}
    >
      <CommonBuilderListTitle title={title} />

      <CommonLayout>
        <CommonBuilderListHeader
          handleSearch={handleSearch}
          title={headerTitle}
        />
        <CommonBuilderListButton title={buttonTitle} onClick={onClick} />
        {children}
      </CommonLayout>
    </Box>
  );
};

export default BuilderListLayout;
